module.exports = __webpack_public_path__ + "media/images/pc/stores/umeda/umeda_concept_03-3ae329501dc6c3309b01f728ee5292d9.jpg";